For best results, select your external microphone and speakers in your
computer's system preferences before selecting the microphone in Spout.
